import * as React from "react";
export default () => <div />;

export const articleQuery = graphql`
  fragment Article on PrismicArticleEdge {
    node {
      id
      uid
      type
      tags
      slugs
      data {
        title
        work_list_title
        lead_in {
          text
          html
        }
        client_name
        type_of_work
        body {
          ... on PrismicArticleBodyQuote {
            primary {
              text {
                html
              }
              attribution
            }
          }
          ... on PrismicArticleBodyText {
            primary {
              text {
                html
              }
            }
          }
          ... on PrismicArticleBodyVideo {
            primary {
              share_link
            }
          }
          ... on PrismicArticleBodyImage {
            items {
              download_link {
                url
              }
              image {
                dimensions {
                  width
                  height
                }
                url
              }
            }
          }
          ... on PrismicArticleBodyHeading {
            id
            primary {
              heading_text {
                html
              }
            }
          }
          ... on PrismicArticleBodyImageGallery {
            primary {
              number_of_columns
            }
            items {
              thumbnail {
                dimensions {
                  width
                  height
                }
                url
              }
              full_resolution {
                dimensions {
                  width
                  height
                }
                url
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/fragments/article.js